import {
  AdminSearchRoomsDocument,
  AdminGetExamRoomByIdDocument,
  GetExamRoomByIdDocument,
  SearchExamCenterRoomsDocument,
  useRetireRoomByIdMutation,
} from '@exam-center/graphql';
import { useCallback } from 'react';

interface RetireExamCenterRoomInput {
  roomId: string;
  remark: string;
}
export function useRetireExamCenterRoom() {
  const [retireRoomById, { loading, error }] = useRetireRoomByIdMutation();
  const retire = useCallback(
    async (input: RetireExamCenterRoomInput) => {
      const { roomId, remark } = input;
      await retireRoomById({
        variables: {
          retireRoomByIdInput: {
            roomId,
            retiredRemark: remark,
          },
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          AdminGetExamRoomByIdDocument,
          GetExamRoomByIdDocument,
          AdminSearchRoomsDocument,
          SearchExamCenterRoomsDocument,
        ],
      });
    },
    [retireRoomById],
  );

  return [retire, { loading, error }] as const;
}
